import { render, staticRenderFns } from "./ExperienceDetails.vue?vue&type=template&id=21fd901e&scoped=true&"
import script from "./ExperienceDetails.vue?vue&type=script&lang=js&"
export * from "./ExperienceDetails.vue?vue&type=script&lang=js&"
import style0 from "./ExperienceDetails.vue?vue&type=style&index=0&id=21fd901e&prod&scoped=true&lang=css&"
import style1 from "./ExperienceDetails.vue?vue&type=style&index=1&id=21fd901e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fd901e",
  null
  
)

export default component.exports